export const MANAGE_MENTEE_MODULES_PAGE_TRACKINGS = {
  deprecateMenteeModule: 'deprecate_mentee_module',
  menteeModuleStatusChange: 'mentee_module_status_change',
  reorderMenteeModules: 'reorder_mentee_modules',
};
